import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMyBotsQuery } from '../../hooks/queries';
import { botDisplayName, botTeamName } from './botDisplay';

/** A bot's name in a list row, with its team after it (team bots), so same-named bots
 * of different teams, or a personal and a team one, can be told apart. */
const BotName = ({ bot, className = '', teamClassName = 'font-normal text-muted-foreground' }) => {
  const { t } = useTranslation();
  const { data } = useMyBotsQuery();
  const full = (bot?.scope ? null : (data?.bots || []).find((b) => b.id === bot?.id)) || bot;
  const name = botDisplayName(full, t);
  const team = botTeamName(full);
  return (
    <span className={`truncate ${className}`} title={[name, team].filter(Boolean).join(' · ')}>
      {name}
      {team && <span className={teamClassName}> · {team}</span>}
    </span>
  );
};

export default BotName;
